"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const formik_1 = require("formik");
const yup = __importStar(require("yup"));
const react_router_dom_1 = require("react-router-dom");
const classnames_1 = __importDefault(require("classnames"));
const LoginImage_1 = __importDefault(require("../../../components/LoginImage"));
const InputField_1 = __importDefault(require("../../../components/InputField/InputField"));
const store_1 = require("../../../store/store");
const Register = () => {
    const location = (0, react_router_dom_1.useLocation)();
    const [selectedContactWay, setSelectedContactWay] = (0, react_1.useState)(undefined);
    const [error, setError] = (0, react_1.useState)(null);
    const [success, setSuccess] = (0, react_1.useState)(null);
    const appSettings = (0, store_1.useAppSelector)((state) => state.app.appSettings);
    const resetPasswordMethods = appSettings === null || appSettings === void 0 ? void 0 : appSettings.resetPasswordMethods;
    (0, react_1.useEffect)(() => {
        setSelectedContactWay(resetPasswordMethods === null || resetPasswordMethods === void 0 ? void 0 : resetPasswordMethods[0]);
    }, [resetPasswordMethods]);
    const onRegister = (0, react_1.useMemo)(() => _.includes(location.pathname, 'register'), [location.pathname]);
    const handleSubmit = (values) => {
        axios
            .post('/api/auth/register', Object.assign(Object.assign({}, values), { selectedContactWay }))
            .then(() => {
            setError(null);
            setSuccess(`${__.trans('register.password-is-sent-to')} ${selectedContactWay === 'email' ? values.currentEMailAddress : values.currentMobileNumber}`);
        })
            .catch((error) => {
            setSuccess(null);
            setError(error.message);
        });
    };
    const validationSchema = (0, react_1.useMemo)(() => {
        let schema = {
            donorIdentity: yup
                .string()
                .required(__.trans('login.validation-id-required'))
                .matches(/^\d{6,8}[-|(\s)]{0,1}\d{4}$/, __.trans('login.validation-id-matches', {
                style: '990101-1234',
            })),
        };
        if (selectedContactWay === 'email') {
            schema = Object.assign(Object.assign({}, schema), { currentEMailAddress: yup
                    .string()
                    .email(__.trans('register.validation-email-not-valid'))
                    .required(__.trans('register.validation-email-required')) });
        }
        else {
            schema = Object.assign(Object.assign({}, schema), { currentMobileNumber: yup
                    .string()
                    .required(__.trans('register.validation-phone-required'))
                    .matches(/^\d+$/, __.trans('register.validation-phone-numbers')) });
        }
        return yup.object().shape(schema);
    }, [selectedContactWay]);
    return ((0, jsx_runtime_1.jsxs)("div", { id: "login-view", children: [(0, jsx_runtime_1.jsxs)("div", { className: "login-container", children: [(0, jsx_runtime_1.jsx)("h5", { className: "form-title", children: onRegister
                            ? __.trans('register.register-form-title')
                            : __.trans('register.passwordreset-form-title') }), (0, jsx_runtime_1.jsx)(formik_1.Formik, { initialValues: {
                            donorIdentity: '',
                            currentEMailAddress: '',
                            currentMobileNumber: '',
                        }, onSubmit: handleSubmit, validationSchema: validationSchema, children: (0, jsx_runtime_1.jsxs)(formik_1.Form, { children: [(0, jsx_runtime_1.jsx)(InputField_1.default, { name: "donorIdentity", type: "text", label: "Personnummer", autoComplete: "username" }), (0, jsx_runtime_1.jsx)("div", { id: "delivery-method", className: "mt-4 mb-1", children: __.trans('register.choose-delivery-method') }), (0, jsx_runtime_1.jsx)("div", { className: "btn-group btn-group-sm w-100 mb-4", role: "group", "aria-labelledby": "delivery-method", children: resetPasswordMethods &&
                                        resetPasswordMethods.length > 1 &&
                                        (resetPasswordMethods === null || resetPasswordMethods === void 0 ? void 0 : resetPasswordMethods.map((method) => ((0, jsx_runtime_1.jsx)("button", { type: "button", className: (0, classnames_1.default)('btn theme-button-primary', {
                                                active: selectedContactWay === method,
                                            }), onClick: () => setSelectedContactWay(method), "aria-pressed": selectedContactWay === method, children: __.trans(`register.register-form-${method}`) })))) }), selectedContactWay === 'email' ? ((0, jsx_runtime_1.jsx)(InputField_1.default, { id: "currentEMailAddress", name: "currentEMailAddress", type: "email", label: "Epost", autoComplete: "email" })) : ((0, jsx_runtime_1.jsx)(InputField_1.default, { id: "currentMobileNumber", name: "currentMobileNumber", type: "text", label: "Telefonnummer", autoComplete: "phone" })), (0, jsx_runtime_1.jsx)("button", { type: "submit", className: "btn theme-button-primary mt-3 w-100", children: onRegister
                                        ? __.trans('register.register-form-submit')
                                        : __.trans('register.passwordreset-form-submit') }), error && (0, jsx_runtime_1.jsx)("div", { className: "alert alert-danger mt-5", children: error }), success && ((0, jsx_runtime_1.jsx)("div", { className: "primary alert-primary mt-5", children: (0, jsx_runtime_1.jsx)("p", { children: success }) }))] }) }), (0, jsx_runtime_1.jsx)("div", { className: "mt-4", children: (0, jsx_runtime_1.jsx)(react_router_dom_1.NavLink, { to: "/auth/login", children: __.trans('register.go-back') }) })] }), (0, jsx_runtime_1.jsx)(LoginImage_1.default, {})] }));
};
exports.default = Register;
